export type CellValue = string | number | boolean | null

export type CellBorderStyle = 'thin' | 'medium' | 'thick' | 'dashed' | 'dotted' | 'double'

export interface CellBorder {
  style: CellBorderStyle
  color: string
}

export interface CellStyle {
  bold?: boolean
  italic?: boolean
  underline?: boolean
  color?: string
  bg?: string
  align?: 'left' | 'center' | 'right'
  /** Excel 표시 형식 문자열. 예: "#,##0", "0.00%", "yyyy-mm-dd", "₩#,##0" */
  numFmt?: string
  fontSize?: number
  fontFamily?: string
  verticalAlign?: 'top' | 'middle' | 'bottom'
  wrap?: boolean
  indent?: number
  textRotation?: number
  borderTop?: CellBorder
  borderRight?: CellBorder
  borderBottom?: CellBorder
  borderLeft?: CellBorder
}

export interface Cell {
  /** 리터럴 값 (수식 셀이면 미사용) */
  v?: CellValue
  /** '=' 로 시작하는 수식 원문 */
  f?: string
  s?: CellStyle
}

export interface SheetImage {
  id: string
  name: string
  src: string
  x: number
  y: number
  width: number
  height: number
}

export interface Sheet {
  id: string
  name: string
  /** key = "A1" 형식의 A1 주소 */
  cells: Record<string, Cell>
  rows: number
  cols: number
  /** 1-based 열 번호 → px */
  colWidths: Record<number, number>
  /** 1-based 행 번호 → px */
  rowHeights: Record<number, number>
  images?: SheetImage[]
  merges?: CellRange[]
  frozenRows?: number
}

export interface Workbook {
  sheets: Sheet[]
  activeSheetId: string
}

export interface CellRange {
  r1: number
  c1: number
  r2: number
  c2: number
}

export const DEFAULT_COL_WIDTH = 104
export const DEFAULT_ROW_HEIGHT = 26
export const HEADER_HEIGHT = 26
export const ROW_HEADER_WIDTH = 52
